document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".model-container").forEach(container => {

    const overlay = container.querySelector(".click-overlay");
    const model = container.querySelector("model-viewer");

    if (!overlay || !model) return;

    overlay.addEventListener("click", () => {

      container.classList.add("revealed");

      try {
        model.dismissPoster?.();
        model.activate?.();
      } catch (e) {
        console.warn("Model reveal failed", e);
      }
    });
  });
});


